module.exports = __webpack_public_path__ + "static/placeholder-wide-64afe68318c311dfc7225beef0a3203c.png";